import React from 'react';
import { IonCol, IonContent, IonPage, IonRow } from "@ionic/react";

export default function PolicyWithoutLogin({renderHeaderPage}) {
    return (
        <IonPage>
            {renderHeaderPage && renderHeaderPage()}
            <IonContent fullscreen className="common-content page-content">
                <div className="desktop-contain-aboutus">
                    <IonRow>
                        <IonCol size="12" sizeMd="9" className="text-left">
                            <h1 className="m-0 p-heading">CA World App – Privacy Policy & Terms</h1>

                            <h4 className="s-heading-r">1. Introduction</h4>
                            <p className="text-left l-height-24 fw-400">
                                Welcome to CA World App. By downloading or using the app, you agree to the terms outlined here.
                                Please read carefully before proceeding.
                            </p>

                            <h4 className="s-heading-r">2. Information We Collect</h4>
                            <p className="text-left l-height-24 fw-400">
                                We collect only what’s necessary to provide services:
                                <ul>
                                    <li>Basic details: Name, email, mobile number, membership ID (if applicable).</li>
                                    <li>Usage data: Features you use, app activity (to improve experience).</li>
                                    <li>Device data: Device type, IP address (for security).</li>
                                </ul>
                                We do not sell or trade your personal data.
                            </p>

                            <h4 className="s-heading-r">3. How We Use Your Data</h4>
                            <ul>
                                <li>To verify your account and personalize your experience.</li>
                                <li>To send important updates, notifications, and professional alerts.</li>
                                <li>To improve app security and performance.</li>
                            </ul>

                            <h4 className="s-heading-r">4. Data Sharing</h4>
                            <ul>
                                <li>With your consent (e.g., networking features).</li>
                                <li>With trusted partners (e.g., payment gateway, analytics).</li>
                                <li>If required by law or regulators.</li>
                            </ul>

                            <h4 className="s-heading-r">5. Your Rights</h4>
                            <ul>
                                <li>Access or update your profile.</li>
                                <li>Request data deletion (unless required by law).</li>
                                <li>Opt-out of promotional messages.</li>
                            </ul>

                            <h4 className="s-heading-r">6. Security</h4>
                            <p className="text-left l-height-24 fw-400">
                                We use encryption, secure servers, and authentication to protect your data.
                            </p>

                            <h4 className="s-heading-r">7. Disclaimer & Liability</h4>
                            <ul>
                                <li><b>Information Accuracy:</b> Content provided is for general guidance. We are not responsible for errors, omissions, or reliance on app content for professional/financial decisions.</li>
                                <li><b>Third-Party Links:</b> The app may contain external links; we do not control or endorse their policies.</li>
                                <li><b>No Liability:</b> CA World is not liable for losses, damages, or claims arising from app usage, data loss, or service interruptions.</li>
                                <li><b>Professional Advice:</b> This app does not substitute independent professional or legal advice.</li>
                            </ul>

                            <h4 className="s-heading-r">8. Termination of Use</h4>
                            <ul>
                                <li>You provide false information.</li>
                                <li>You misuse app features or breach terms.</li>
                            </ul>

                            <h4 className="s-heading-r">9. Changes to Policy</h4>
                            <p className="text-left l-height-24 fw-400">
                                We may update this policy from time to time. Major changes will be notified in-app or via email.
                            </p>

                            <h4 className="s-heading-r">10. Contact Us</h4>
                            <p className="text-left l-height-24 fw-400">
                                📧 <b>Email:</b> support@caworld.com<br />
                                📞 <b>Phone:</b> +91 9711310004<br />
                                📍 <b>Address:</b> 4696 Brij Bhawan, 21A Ansari Road, Daryaganj, New Delhi – 110002
                            </p>
                        </IonCol>
                    </IonRow>
                </div>
            </IonContent>
        </IonPage>
    );
}
